export const ROLES = {
  ADMINISTRATOR: 'administrator',
  EXECUTIVE: 'executive',
  MANAGER: 'manager',
  STAFF: 'staff',
  DRIVER: 'driver',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export default ROLES;
